import React from 'react'

export function Header(){
   
    return(
        <div className="header">
            <div className="logo"><img src="./logo.jpg" alt="logo"/></div>
            <h1>Meme Generator</h1>
        </div>
    )
    
}